var _path, _rect, _polygon, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFhpLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 438,
    height: 77.4,
    viewBox: "0 0 438 77.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.3,57.2c0,8.2-1.9,14.4-9.3,20.2l-8.1-6.8c4.2-4,5.6-7,5.7-11.9h-6.5V40.3h18.2Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 112.3,
    y: 9.8,
    width: 18,
    height: 18.3,
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "0 58.7 0 0.7 43.6 0.7 43.6 14.5 17.5 14.5 17.5 24.7 41.6 24.7 41.6 38.5 17.5 38.5 17.5 58.7 0 58.7",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3,58.7V36h-17V58.7H49.4V.7H67.3V21.1H84.2V.7h18v58Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5,58.7V.7h24.8c11.4,0,16.3,1.2,19.8,3.5,5.1,3.4,7.6,8.9,7.6,16.1,0,6.7-2.6,12.5-7.3,15.9-4,2.9-9.3,4.3-18.3,4.3h-8.8V58.7ZM165.1,27c3.5,0,6-.5,7.4-1.6a5.69,5.69,0,0,0,1.8-4.6,6,6,0,0,0-1.8-4.6c-1.3-1.2-3.4-1.6-7.1-1.6h-7.1V27Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M223.8,2.8V6.6h3.8v2h-3.8v5.7h-2.7V.7h7V2.8Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M235.6,14.3l-.2-1a4.85,4.85,0,0,1-3.1,1.3c-2,0-3.1-1-3.1-2.9,0-2.1,1.7-3.5,5.2-3.5h.6V7.4c0-1-.6-1.5-1.9-1.5a10.66,10.66,0,0,0-3.1.6l-.3-1.6a10.31,10.31,0,0,1,4.1-.9c2.6,0,3.8,1.2,3.8,3.1v7.2ZM235,9.7h-.8c-2,0-2.5.6-2.5,1.6a1.24,1.24,0,0,0,1.4,1.3,2.8,2.8,0,0,0,1.9-.9v-2Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M243.9,14.5c-2.7,0-4-1.7-4-5.1,0-3.2,1.6-5.4,4.2-5.4a3.84,3.84,0,0,1,3,1.3l-.9,1.3a2.61,2.61,0,0,0-1.7-.7c-1.2,0-1.9,1.1-1.9,3.2,0,2.5.7,3.4,1.8,3.4a3.23,3.23,0,0,0,2.1-.8l.8,1.3A4.37,4.37,0,0,1,243.9,14.5Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M257.5,14.3h-2.6c0-2.1.1-4.2.1-5.3,0-2.4-.5-3-1.4-3a3.7,3.7,0,0,0-1.9.8v7.4h-2.6V0h2.6V5.1A4.41,4.41,0,0,1,254.5,4c2,0,3.1,1.3,3.1,4.6C257.6,9.8,257.5,12.1,257.5,14.3Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M268.8,14.3h-2.6c0-2.1.1-4.2.1-5.3,0-2.4-.5-3-1.4-3a3.7,3.7,0,0,0-1.9.8v7.4h-2.6V0H263V5.1A4.41,4.41,0,0,1,265.8,4c2,0,3.1,1.3,3.1,4.6C268.9,9.8,268.8,12.1,268.8,14.3Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M275.6,14.5c-2.9,0-4.5-1.5-4.5-5.1S273,3.9,276,3.9s4.5,1.5,4.5,5.1C280.5,12.8,278.6,14.5,275.6,14.5Zm.2-8.6c-1.2,0-2,.8-2,3.1,0,2.8.7,3.6,2,3.6s2-.8,2-3.1C277.9,6.6,277.1,5.9,275.8,5.9Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M286.4,14.5c-2.7,0-4-1.7-4-5.1,0-3.2,1.6-5.4,4.2-5.4a3.84,3.84,0,0,1,3,1.3l-.9,1.3a2.61,2.61,0,0,0-1.7-.7c-1.2,0-1.9,1.1-1.9,3.2,0,2.5.7,3.4,1.8,3.4a3.23,3.23,0,0,0,2.1-.8l.8,1.3A4.71,4.71,0,0,1,286.4,14.5Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M299.9,14.3h-2.6c0-2.1.1-4.2.1-5.3,0-2.4-.5-3-1.4-3a3.7,3.7,0,0,0-1.9.8v7.4h-2.6V0h2.6V5.1A4.41,4.41,0,0,1,296.9,4c2,0,3.1,1.3,3.1,4.6C300,9.8,299.9,12.1,299.9,14.3Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M305.2,14.5a6.5,6.5,0,0,1-3.1-.8l.2-1.4a8.69,8.69,0,0,0,2.5.3c1.3,0,1.8-.5,1.8-1.1s-.3-1-1.8-1.5c-1.9-.7-2.7-1.5-2.7-3,0-1.8,1.5-3.1,3.7-3.1a6.09,6.09,0,0,1,2.8.7L308.3,6a8.08,8.08,0,0,0-2-.3c-1,0-1.5.5-1.5,1s.3.9,1.8,1.4c2,.7,2.7,1.6,2.7,3.1C309.3,13.1,307.8,14.5,305.2,14.5Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M315,14.5c-2.7,0-4-1.7-4-5.1,0-3.2,1.6-5.4,4.2-5.4a3.84,3.84,0,0,1,3,1.3l-.9,1.3a2.61,2.61,0,0,0-1.7-.7c-1.2,0-1.9,1.1-1.9,3.2,0,2.5.7,3.4,1.8,3.4a3.23,3.23,0,0,0,2.1-.8l.8,1.3A4.71,4.71,0,0,1,315,14.5Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M328.5,14.3h-2.6c0-2.1.1-4.2.1-5.3,0-2.4-.5-3-1.4-3a3.7,3.7,0,0,0-1.9.8v7.4h-2.6V0h2.6V5.1A4.41,4.41,0,0,1,325.5,4c2,0,3.1,1.3,3.1,4.6C328.6,9.8,328.5,12.1,328.5,14.3Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M337.7,14.3l-.2-1.1a4.53,4.53,0,0,1-3,1.3c-2.1,0-3.1-1.3-3.1-4.6,0-1.3.1-3.5.1-5.7h2.6c0,2-.1,4.1-.1,5.3,0,2.4.5,2.9,1.4,2.9a3.4,3.4,0,0,0,1.9-.8V4.2h2.6V14.3Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M344.7,14.5c-1.3,0-2-.4-2-2V0h2.6V11.4c0,1.1.1,1.3.7,1.3h.5l.1,1.5A5,5,0,0,1,344.7,14.5Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M350.5,9.8v.1c0,1.9.8,2.6,2.3,2.6a11,11,0,0,0,3.3-.6l.4,1.5a9.69,9.69,0,0,1-4.2,1.1c-2.6,0-4.4-1.3-4.4-5S349.7,4,352.5,4c2.6,0,4.3,1.5,4,5.8Zm3.4-1.7c0-1.6-.5-2.4-1.6-2.4s-1.7,1-1.8,2.4Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M367.6,9.7H367v4.6h-2.7V.7h4c3.7,0,5,1.7,5,4.3S371.8,9.7,367.6,9.7Zm.2-7.1H367V7.7h.8c1.8,0,2.6-.9,2.6-2.5S369.7,2.6,367.8,2.6Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M379.1,14.5c-2.9,0-4.5-1.5-4.5-5.1s1.9-5.5,4.9-5.5S384,5.4,384,9C384,12.8,382.1,14.5,379.1,14.5Zm.2-8.6c-1.2,0-2,.8-2,3.1,0,2.8.7,3.6,2,3.6s2-.8,2-3.1C381.3,6.6,380.6,5.9,379.3,5.9Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M389,14.5c-1.9,0-2.6-.7-2.6-2.6V6h-1.3V4.2h1.4c.2-.9.4-1.8.6-2.9H389V4.2h2.2V6H389v5.2c0,1,.2,1.4.9,1.4a4.5,4.5,0,0,0,1.4-.2l.2,1.5A6.08,6.08,0,0,1,389,14.5Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M395.9,14.5a6.5,6.5,0,0,1-3.1-.8l.2-1.4a8.69,8.69,0,0,0,2.5.3c1.3,0,1.8-.5,1.8-1.1s-.3-1-1.8-1.5c-1.9-.7-2.7-1.5-2.7-3,0-1.8,1.5-3.1,3.7-3.1a6.09,6.09,0,0,1,2.8.7L399.1,6a8.08,8.08,0,0,0-2-.3c-1,0-1.5.5-1.5,1s.3.9,1.8,1.4c2,.7,2.7,1.6,2.7,3.1C400.1,13.1,398.5,14.5,395.9,14.5Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M408.3,14.3l-.2-1a4.55,4.55,0,0,1-2.8,1.3c-2.4,0-3.5-2.2-3.5-4.9,0-4.1,2.2-5.7,5-5.7a3.42,3.42,0,0,1,1.1.1V0h2.6V14.3ZM407.8,6a5,5,0,0,0-1.2-.2c-1.3,0-2.2,1.1-2.2,3.5,0,2.1.6,3.2,1.7,3.2a3.44,3.44,0,0,0,1.8-.8V6Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M419.1,14.3l-.2-1a4.85,4.85,0,0,1-3.1,1.3c-2,0-3.1-1-3.1-2.9,0-2.1,1.7-3.5,5.2-3.5h.6V7.4c0-1-.6-1.5-1.9-1.5a10.66,10.66,0,0,0-3.1.6l-.3-1.6a10.31,10.31,0,0,1,4.1-.9c2.6,0,3.8,1.2,3.8,3.1v7.2Zm-.6-4.6h-.8c-2,0-2.5.6-2.5,1.6a1.24,1.24,0,0,0,1.4,1.3,2.8,2.8,0,0,0,1.9-.9Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M437.9,14.3h-2.6c0-2,.1-4.1.1-5.3,0-2.4-.4-3-1.3-3a3.64,3.64,0,0,0-1.9.9,5.76,5.76,0,0,1,.1,1.5v5.8h-2.6V9c0-2.4-.4-3-1.3-3a3.15,3.15,0,0,0-1.8.8v7.4H424V4.2h2.1l.2,1.1a4.6,4.6,0,0,1,3-1.3,2.61,2.61,0,0,1,2.5,1.5A4.79,4.79,0,0,1,435,4c2,0,3,1.3,3,4.6C438,9.8,437.9,12.1,437.9,14.3Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M225.9,36.7c-3.2,0-4.9-1.4-4.9-4.8v-9h2.7v8.7c0,2.3.7,3.1,2.4,3.1,1.5,0,2.4-.7,2.4-3V22.8h2.7v8.7C231.2,35.3,229,36.7,225.9,36.7Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M242.7,36.5h-2.6c0-2,.1-4.1.1-5.3,0-2.4-.5-2.9-1.4-2.9a3.7,3.7,0,0,0-1.9.8v7.4h-2.6V26.4h2.1l.2,1.1a4.57,4.57,0,0,1,3.1-1.3c2,0,3.1,1.3,3.1,4.6C242.8,32,242.7,34.3,242.7,36.5Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M247,25.1c-1.2,0-1.6-.3-1.6-1.4s.3-1.4,1.6-1.4,1.5.3,1.5,1.4S248.2,25.1,247,25.1Zm-1.4,11.4V26.4h2.6V36.5Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M256.4,36.5H253l-2.9-10.1h2.8l1.6,5.7.4,2a46.61,46.61,0,0,0,1.7-7.7h2.7A39,39,0,0,1,256.4,36.5Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M263.2,31.9V32c0,1.9.8,2.6,2.3,2.6a11,11,0,0,0,3.3-.6l.4,1.5a9.69,9.69,0,0,1-4.2,1.1c-2.6,0-4.4-1.3-4.4-5s1.8-5.5,4.6-5.5c2.6,0,4.3,1.5,4,5.8Zm3.5-1.6c0-1.6-.5-2.4-1.6-2.4s-1.7,1-1.8,2.4Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M277.2,28.7a3.44,3.44,0,0,0-.9-.1c-.6,0-1,.4-2,1.5v6.4h-2.6V26.4h2.1L274,28c1-1.4,1.7-1.8,2.4-1.8a4.4,4.4,0,0,1,1,.2Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M281.7,36.7a6.5,6.5,0,0,1-3.1-.8l.2-1.4a8.35,8.35,0,0,0,2.5.3c1.3,0,1.8-.5,1.8-1.1s-.3-1-1.8-1.5c-1.9-.7-2.7-1.5-2.7-3,0-1.8,1.5-3.1,3.7-3.1a6.09,6.09,0,0,1,2.8.7l-.3,1.3a8.08,8.08,0,0,0-2-.3c-1,0-1.5.5-1.5,1s.3.9,1.8,1.4c2,.7,2.7,1.6,2.7,3.1C285.8,35.3,284.3,36.7,281.7,36.7Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M289.3,25.1c-1.2,0-1.6-.3-1.6-1.4s.3-1.4,1.6-1.4,1.5.3,1.5,1.4S290.5,25.1,289.3,25.1Zm-1.4,11.4V26.4h2.6V36.5Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M296.2,36.7c-1.9,0-2.6-.7-2.6-2.6V28.3h-1.3V26.5h1.4c.2-.9.4-1.8.6-2.9h1.9v2.9h2.2v1.8h-2.2v5.2c0,1,.2,1.4.9,1.4a4.5,4.5,0,0,0,1.4-.2l.2,1.5A7.93,7.93,0,0,1,296.2,36.7Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M301.1,40.1a3.07,3.07,0,0,1-1.5-.4V38.2c.3,0,.8.1,1,.1a2.41,2.41,0,0,0,1.5-.4,1.56,1.56,0,0,0,.6-1.2,5.54,5.54,0,0,0-.5-2l-2.5-8.2h2.8L304,32a6.39,6.39,0,0,1,.4,2.5,36.17,36.17,0,0,0,1.7-8.2h2.7C307.2,36.9,303.9,40.1,301.1,40.1Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M319,36.7c-2.9,0-4.5-1.5-4.5-5.1s1.9-5.5,4.9-5.5,4.5,1.5,4.5,5.1C323.9,35,322,36.7,319,36.7Zm.2-8.6c-1.2,0-2,.8-2,3.1,0,2.8.7,3.6,2,3.6s2-.8,2-3.1C321.2,28.8,320.5,28.1,319.2,28.1Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M331.3,24.1a2.54,2.54,0,0,0-1.2-.2c-.8,0-1.1.4-1.1,1.3v1.3h1.8v1.8H329v8.3h-2.6V28.3h-1.3V26.5h1.3V25.3c0-2,.8-3.2,2.8-3.2a5.28,5.28,0,0,1,2.4.6Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M228,58.7c-.2-.8-.4-1.9-.6-2.7h-4.5c-.2.8-.4,1.8-.6,2.7h-2.6a130.81,130.81,0,0,1,3.8-13.6h3.6a120.72,120.72,0,0,1,3.8,13.6Zm-2.9-11.2c-.6,1.9-1.2,4.4-1.8,6.5h3.6C226.4,51.9,225.8,49.6,225.1,47.5Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M236.4,58.9a4.48,4.48,0,0,1-1.1-.1v3.3h-2.6V48.6h2.1l.2,1a4.55,4.55,0,0,1,2.8-1.3c2.4,0,3.6,2.2,3.6,4.9C241.5,57.2,239.3,58.9,236.4,58.9Zm.8-8.6a3.44,3.44,0,0,0-1.8.8v5.6a4.3,4.3,0,0,0,1.2.2c1.3,0,2.2-1.1,2.2-3.5C238.8,51.5,238.2,50.3,237.2,50.3Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M247.5,58.9a4.48,4.48,0,0,1-1.1-.1v3.3h-2.6V48.6h2.1l.2,1a4.55,4.55,0,0,1,2.8-1.3c2.4,0,3.6,2.2,3.6,4.9C252.5,57.2,250.4,58.9,247.5,58.9Zm.7-8.6a3.44,3.44,0,0,0-1.8.8v5.6a4.3,4.3,0,0,0,1.2.2c1.3,0,2.2-1.1,2.2-3.5C249.9,51.5,249.3,50.3,248.2,50.3Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M256.9,58.8c-1.3,0-2-.4-2-2V44.4h2.6V55.8c0,1.1.1,1.3.7,1.3h.5l.1,1.5A9.2,9.2,0,0,1,256.9,58.8Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M262.1,47.3c-1.2,0-1.6-.3-1.6-1.4s.3-1.4,1.6-1.4,1.5.3,1.5,1.4S263.3,47.3,262.1,47.3Zm-1.3,11.4V48.6h2.6V58.7Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M268.4,54.1v.1c0,1.9.8,2.6,2.3,2.6a11,11,0,0,0,3.3-.6l.4,1.5a9.69,9.69,0,0,1-4.2,1.1c-2.6,0-4.4-1.3-4.4-5s1.8-5.5,4.6-5.5c2.6,0,4.3,1.5,4,5.8Zm3.4-1.6c0-1.6-.5-2.4-1.6-2.4s-1.7,1-1.8,2.4Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M282.9,58.7l-.2-1a4.55,4.55,0,0,1-2.8,1.3c-2.4,0-3.5-2.2-3.5-4.9,0-4.1,2.2-5.7,5-5.7a3.42,3.42,0,0,1,1.1.1v-4h2.6V58.8h-2.2Zm-.5-8.3a5,5,0,0,0-1.2-.2c-1.3,0-2.2,1.1-2.2,3.5,0,2.1.6,3.2,1.7,3.2a3.44,3.44,0,0,0,1.8-.8V50.4Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M296.6,58.9a7.14,7.14,0,0,1-4.1-1.3l.6-1.4a10,10,0,0,0,2.9.7c1.4,0,2.3-.6,2.3-1.8,0-2.7-5.7-2.1-5.7-6.4,0-2.3,1.8-3.8,4.4-3.8a5.89,5.89,0,0,1,3.6,1.1l-.6,1.4a8.5,8.5,0,0,0-2.5-.5c-1.4,0-2,.6-2,1.6,0,2.7,5.8,2.2,5.8,6.4C301.3,57.1,299.6,58.9,296.6,58.9Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M307,58.9c-2.7,0-4-1.7-4-5.1,0-3.2,1.6-5.4,4.2-5.4a3.84,3.84,0,0,1,3,1.3l-.9,1.3a2.61,2.61,0,0,0-1.7-.7c-1.2,0-1.9,1.1-1.9,3.2,0,2.5.7,3.4,1.8,3.4a3.23,3.23,0,0,0,2.1-.8l.8,1.3A4.37,4.37,0,0,1,307,58.9Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M313.7,47.3c-1.2,0-1.6-.3-1.6-1.4s.3-1.4,1.6-1.4,1.5.3,1.5,1.4S315,47.3,313.7,47.3Zm-1.3,11.4V48.6H315V58.7Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M320,54.1v.1c0,1.9.8,2.6,2.3,2.6a11,11,0,0,0,3.3-.6l.4,1.5a9.69,9.69,0,0,1-4.2,1.1c-2.6,0-4.4-1.3-4.4-5s1.8-5.5,4.6-5.5c2.6,0,4.3,1.5,4,5.8Zm3.5-1.6c0-1.6-.5-2.4-1.6-2.4s-1.7,1-1.8,2.4Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M336.9,58.7h-2.6c0-2,.1-4.1.1-5.3,0-2.4-.5-2.9-1.4-2.9a3.7,3.7,0,0,0-1.9.8v7.4h-2.6V48.6h2.1l.2,1.1a4.57,4.57,0,0,1,3.1-1.3c2,0,3.1,1.3,3.1,4.6C337,54.2,336.9,56.5,336.9,58.7Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M343.3,58.9c-2.7,0-4-1.7-4-5.1,0-3.2,1.6-5.4,4.2-5.4a3.84,3.84,0,0,1,3,1.3l-.9,1.3a2.61,2.61,0,0,0-1.7-.7c-1.2,0-1.9,1.1-1.9,3.2,0,2.5.7,3.4,1.8,3.4a3.23,3.23,0,0,0,2.1-.8l.8,1.3A4.71,4.71,0,0,1,343.3,58.9Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M350.4,54.1v.1c0,1.9.8,2.6,2.3,2.6a11,11,0,0,0,3.3-.6l.4,1.5a9.69,9.69,0,0,1-4.2,1.1c-2.6,0-4.4-1.3-4.4-5s1.8-5.5,4.6-5.5c2.6,0,4.3,1.5,4,5.8Zm3.5-1.6c0-1.6-.5-2.4-1.6-2.4s-1.7,1-1.8,2.4Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M361.3,58.9a6.5,6.5,0,0,1-3.1-.8l.2-1.4a8.35,8.35,0,0,0,2.5.3c1.3,0,1.8-.5,1.8-1.1s-.3-1-1.8-1.5c-1.9-.7-2.7-1.5-2.7-3,0-1.8,1.5-3.1,3.7-3.1a6.09,6.09,0,0,1,2.8.7l-.3,1.3a8.08,8.08,0,0,0-2-.3c-1,0-1.5.5-1.5,1s.3.9,1.8,1.4c2,.7,2.7,1.6,2.7,3.1C365.4,57.5,363.9,58.9,361.3,58.9Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFhpLogoWhite);
export default __webpack_public_path__ + "static/media/FHP_logo_white.3c361833702bfa035dc2e514fa9fe37a.svg";
export { ForwardRef as ReactComponent };